import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../../services/api';
import { QueryGrid, QueryGridSelectMode } from '../../../shared/grid/queryGrid/queryGrid';
import { Button } from '../../../shared/inputs/button';

import styles from './reportsList.module.css';
import { REPORT } from '../../../../permissions';

export const ReportsList = (props) => {

    return <QueryGrid
        queryParamPrefix=''
        singleResourceName='Report'
        pluralResourceName='Reports'
        nameFunction={r => r.name}
        restEndpoint='/communications/reports/'
        listUrl='/reports/'
        actions={[]}
        readPermissions={[REPORT.READ]}
        writePermissions={[REPORT.WRITE]}
        selectMode={QueryGridSelectMode.None}
        columns={{
            name: {
                label: 'Name',
                passOnClick: true,
                formatFunction: r => <Link to={pathJoin('/reports/', r.id)}>{r.name}</Link>,
            },
            ivr: {
                label: 'IVR',
                formatFunction: r => r.ivr,
            },
            description: {
                label: 'Description',
                size: '60%',
                formatFunction: r => <div className={styles.OneLine}>{r.description}</div>
            },
            actions: {
                label: '',
                size: '135px',
                formatFunction: r => <Link to={pathJoin('/reports/', r.id)}><Button className='primary thin'>Generate</Button></Link>
            }
        }}
        {...props}
    />
}